import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVendorsQuery = () => {
  return axios.get(apiurl?.getVendorDashBoardVendorList);
};

const getVendorDashboardVendorList = () => {
  return useQuery(['getVendorListbyCompany'], () => getVendorsQuery(), { refetchOnWindowFocus: false });
};

export default getVendorDashboardVendorList;
